import { defineMessages } from 'react-intl'

export default defineMessages({
  successUpload: {
    id: 'containers.SupplierTaskPage.components.FileUpload.successUpload',
    defaultMessage: 'File uploaded',
  },
  dragActive: {
    id: 'containers.SupplierTaskPage.components.FileUpload.dragActive',
    defaultMessage: 'Drop files here ...',
  },
  dragInActive: {
    id: 'containers.SupplierTaskPage.components.FileUpload.dragInActive',
    defaultMessage: 'Drag and drop files here, or',
  },
  uploadFilesHere: {
    id: 'containers.SupplierTaskPage.components.FileUpload.uploadFilesHere',
    defaultMessage: 'Upload your files here',
  },
  
})
